import { nextTick } from "vue";
import i18n from "@/packages/i18n";
import { useGlobalStore } from "@/stores/globalStore";

export const LOCALES = [
  {
    name: "English",
    value: "en",
  },
  {
    name: "Portuguese",
    value: "pt",
  },
  {
    name: "Turkish",
    value: "tr",
  },
];

/**
 * Get Supported Locales
 *
 * @returns {array} supported locales
 */
const supportedLocales = () => {
  return import.meta.env.VITE_SUPPORTED_LOCALES.split(",");
};

/**
 * Set Current Locale
 */
const setCurrentLocale = (newLocale) => {
  i18n.global.locale.value = newLocale;
};

export const selectedLocale = () => {
  return LOCALES.find((locale) => locale.value === getPersistedLocale());
};

/**
 * Load Locale Messages
 */
export const loadLocaleMessages = async (locale) => {
  try {
    const messages = await import(`./locales/${locale}.json`);
    i18n.global.setLocaleMessage(locale, messages.default);
    return nextTick();
  } catch (error) {
    console.error(error);
  }
};

/**
 * Switch Locale
 */
export const switchLanguage = async (newLocale) => {
  const globalStore = useGlobalStore();

  await loadLocaleMessages(newLocale);
  setCurrentLocale(newLocale);
  globalStore.setLanguage(newLocale);
};

export const getPersistedLocale = () => {
  const persistedLocale = localStorage.getItem("locale");

  if (supportedLocales().some((locale) => locale === persistedLocale)) {
    return persistedLocale;
  }

  return import.meta.env.VITE_DEFAULT_LOCALE;
};
